import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserDepositContainer from 'containers/user/UserDepositContainer';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';

class Deposit extends Component {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>예치금 | 캐시바이</title>
          </Helmet>
          <UserDepositContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default Deposit;



// WEBPACK FOOTER //
// ./src/pages/user/Deposit.js